import { createContext } from 'react';

export const TXNativeContext = createContext({
  instance: null,
});
